const splitIntoChunks = <T>(array: T[], chunkSize: number): T[][] => {
  const chunks = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}

export default splitIntoChunks
